
import  { useEffect, useState,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Image, Spinner } from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import './job-title.css';

import logo from "../../../assets/images/MTDlogo.png";
import backarrow from "../../../assets/images/backarrow.jpg";
import responsivebg from "../../../assets/images/responsive-bg.png";

import Stepper from '../Stepper';
import * as masterConstantActions from "../../../actions/masterConstant"
import * as userAction from "../../../actions/user"

export default function KidsAndFamily() {
  const [selectedHaveKids, setSelectedHaveKids] = useState(null);
  const [selectedWantKids, setSelectedWantKids] = useState(null);
  const [errorMessagehaveKids, setErrorMessagehaveKids] = useState("")
  const [errorMessageWantKids, setErrorMessageWantKids] = useState("")
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [familyOptions,setFamilyOptions] = useState([]);
  const [kidsOptions,setKidsOptions] = useState([]);
  const isFetched = useRef(false);
  


  const fetchWantKids = async () => {
      try {
        const response = await masterConstantActions.getConstantWantKids();
        if (response.status && response.data.length > 0) {
          setFamilyOptions(response.data);
        }
      } catch (error) {
        console.error("Error fetching growth options:", error);
      }
  };

  const fetchHaveKids = async () => {
      try {
        const response = await masterConstantActions.getConstantHaveKids();
        if (response.status && response.data.length > 0) {
          setKidsOptions(response.data);
        }
      } catch (error) {
        console.error("Error fetching growth options:", error);
      }
  };

    const fetchSelectedOptions = async () => {
      try {
        const response = await userAction.getKidsFamily()
        if (response) {
        setSelectedHaveKids(kidsOptions[response.have_kid_id - 1]);
        setSelectedWantKids(familyOptions[response.want_kid_id - 1]);
        }
      } catch (error) {
        console.error("Error fetching selected kids option:", error);
      }
    };

  useEffect(() => {
    if (isFetched.current) return;
    isFetched.current = true;

    fetchWantKids();
    fetchHaveKids();
  },[]);

  useEffect(() => {
    if (kidsOptions?.length > 0 ||  familyOptions?.length > 0 ) {
      fetchSelectedOptions();
    }
  }, [kidsOptions,familyOptions]);

  async function saveHaveKids() {
    if (!selectedHaveKids) {
      setErrorMessagehaveKids("*Please make a selection.");
      return;
    }
    let body= JSON.stringify({ have_kid_id: kidsOptions.indexOf(selectedHaveKids) + 1 })

    const response = await userAction.UpdateKidsFamily(body)
    if (!response) {
      throw new Error('Error saving have kids');
    }
  }

  async function saveWantKids() {

    if (!selectedWantKids) {
      setErrorMessageWantKids("*Please make a selection.");
      return;
    }
     let body= JSON.stringify({ want_kid_id: familyOptions.indexOf(selectedWantKids) + 1 })

    const response = await userAction.UpdateWantKids(body)
    if (!response) {
      throw new Error('Error saving want kids');
    }
  }

  async function saveAll() {
    setErrorMessagehaveKids("");
    setErrorMessageWantKids("")
    if (!selectedHaveKids) {
      setErrorMessagehaveKids("*Please make a selection.");
      return;
    }
    if (!selectedWantKids) {
      setErrorMessageWantKids("*Please make a selection.");
      return;
    }
    setLoading(true)
    try {
      await Promise.all([saveHaveKids(), saveWantKids()]);
      setLoading(false)
      navigate('/smoke-drink');
    } catch (error) {
      setLoading(false)
      console.error('Error saving kids and family:', error);
    }
  }

  return (
    <div className="job-container">
      <div className="job-bg">
        <Image
          className="responsive-bg"
          src={responsivebg}
          alt="Background"
        ></Image>
      </div>
      <Container className="job-main">
        <Container className="job-content">
          <Container className="logo-progressbar10">
            <Container className="logo-arrow10">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()}
                alt="Back Arrow"
              />
              <Image
                src={logo}
                alt="Logo"
                className="logo"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
            <Stepper activeStep="kidsAndFamily" />
          </Container>
          <div className="container-div">
            <div className="container-child1">
              <Container className="job-details">
                <div className="your-job">
                  <Container className="job-text">
                    <p>What about kids?</p>
                  </Container>

                  <div
                    style={{
                      maxHeight: "50vh",
                      overflow: "auto",
                    }}
                  >
                    <div className="job-columns">
                      {kidsOptions?.map((kid, index) => (
                        <div
                          key={index}
                          className="job-item"
                          onClick={() => setSelectedHaveKids(kid)}
                          style={{
                            backgroundColor:
                              selectedHaveKids?.id === kid?.id
                                ? "#F7ECFF"
                                : "transparent",
                          }}
                        >
                          {kid?.name}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: "5px" }}>
                  {errorMessagehaveKids && (
                    <p className="text-danger error-message">
                      {errorMessagehaveKids}
                    </p>
                  )}
                </div>
              </Container>
              <Container className="job-details family-section">
                <div className="your-job">
                  <Container className="job-text">
                    {/* <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="20" cy="20" r="18" fill="#4E1173" />
                                    <path d="M14.2416 22.8521H15.3504C15.7747 22.8521 16.1817 22.6765 16.4817 22.3639C16.7818 22.0514 16.9504 21.6274 16.9504 21.1854V19.4729C16.9504 19.0309 16.7818 18.607 16.4817 18.2944C16.1817 17.9818 15.7747 17.8063 15.3504 17.8063H14.2416C13.8172 17.8063 13.4102 17.9818 13.1102 18.2944C12.8101 18.607 12.6416 19.0309 12.6416 19.4729V21.1854C12.6416 21.6274 12.8101 22.0514 13.1102 22.3639C13.4102 22.6765 13.8172 22.8521 14.2416 22.8521ZM13.4416 19.4729C13.4416 19.2519 13.5258 19.0399 13.6759 18.8837C13.8259 18.7274 14.0294 18.6396 14.2416 18.6396H15.3504C15.5625 18.6396 15.766 18.7274 15.916 18.8837C16.0661 19.0399 16.1504 19.2519 16.1504 19.4729V21.1854C16.1504 21.4064 16.0661 21.6184 15.916 21.7747C15.766 21.931 15.5625 22.0187 15.3504 22.0187H14.2416C14.0294 22.0187 13.8259 21.931 13.6759 21.7747C13.5258 21.6184 13.4416 21.4064 13.4416 21.1854V19.4729ZM17.4496 24.9096C17.3647 24.9759 17.258 25.0044 17.153 24.9887C17.048 24.9731 16.9532 24.9147 16.8896 24.8263C16.7503 24.6317 16.5692 24.4739 16.3608 24.3655C16.1524 24.2571 15.9225 24.2011 15.6896 24.2021H13.9024C13.5044 24.2027 13.1229 24.3678 12.8416 24.661C12.5602 24.9542 12.402 25.3517 12.4016 25.7663V26.5363C13.1695 26.8152 13.9823 26.9349 14.7944 26.8888C15.3028 26.9007 15.8113 26.8678 16.3144 26.7904C16.419 26.7719 16.5264 26.7973 16.6129 26.8613C16.6995 26.9252 16.7581 27.0223 16.776 27.1313C16.7938 27.2402 16.7693 27.3521 16.708 27.4423C16.6466 27.5324 16.5534 27.5935 16.4488 27.6121C15.9018 27.6977 15.3489 27.7345 14.796 27.7221C13.7796 27.7877 12.7626 27.6024 11.828 27.1813C11.7602 27.1472 11.703 27.094 11.663 27.0277C11.6229 26.9614 11.6016 26.8846 11.6016 26.8063V25.7663C11.6022 25.1308 11.8448 24.5216 12.2762 24.0723C12.7075 23.623 13.2923 23.3702 13.9024 23.3696H15.6864C16.0436 23.3678 16.3961 23.4535 16.7157 23.6196C17.0353 23.7858 17.313 24.0278 17.5264 24.3263C17.5901 24.4146 17.6176 24.5256 17.6027 24.635C17.5879 24.7444 17.5319 24.8432 17.4472 24.9096H17.4496ZM28.4016 25.7663V26.8063C28.4016 26.8844 28.3806 26.9611 28.3408 27.0274C28.3011 27.0937 28.2442 27.147 28.1768 27.1813C27.2421 27.6024 26.2252 27.7877 25.2088 27.7221C24.6558 27.7345 24.1029 27.6977 23.556 27.6121C23.5042 27.6029 23.4546 27.5832 23.4101 27.554C23.3657 27.5249 23.3271 27.4869 23.2967 27.4423C23.2663 27.3976 23.2447 27.3472 23.233 27.2938C23.2214 27.2404 23.2199 27.1852 23.2288 27.1313C23.2479 27.023 23.3069 26.9268 23.3931 26.8631C23.4793 26.7995 23.586 26.7734 23.6904 26.7904C24.1935 26.8678 24.7019 26.9007 25.2104 26.8888C26.0219 26.9347 26.8342 26.815 27.6016 26.5363V25.7663C27.6009 25.3518 27.4426 24.9546 27.1613 24.6615C26.88 24.3685 26.4986 24.2036 26.1008 24.2029H24.3168C24.0838 24.202 23.8539 24.2579 23.6455 24.3663C23.4371 24.4748 23.256 24.6326 23.1168 24.8271C23.0852 24.8709 23.0458 24.9077 23.0006 24.9356C22.9554 24.9635 22.9053 24.9818 22.8533 24.9896C22.8013 24.9973 22.7484 24.9943 22.6975 24.9807C22.6466 24.9671 22.5988 24.9432 22.5568 24.9104C22.5147 24.8776 22.4793 24.8365 22.4526 24.7894C22.4258 24.7423 22.4082 24.6902 22.4008 24.636C22.3934 24.5818 22.3962 24.5267 22.4093 24.4737C22.4223 24.4207 22.4452 24.3709 22.4768 24.3271C22.6901 24.0287 22.9678 23.7866 23.2874 23.6205C23.607 23.4543 23.9596 23.3687 24.3168 23.3704H26.1008C26.7106 23.3711 27.2954 23.6237 27.7267 24.0728C28.158 24.522 28.4007 25.131 28.4016 25.7663ZM19.6112 20.2787C19.2505 20.2787 18.9045 20.428 18.6495 20.6937C18.3944 20.9594 18.2512 21.3197 18.2512 21.6954V22.9363C18.2512 23.312 18.3944 23.6723 18.6495 23.938C18.9045 24.2037 19.2505 24.3529 19.6112 24.3529H20.392C20.7527 24.3529 21.0986 24.2037 21.3536 23.938C21.6087 23.6723 21.752 23.312 21.752 22.9363V21.6954C21.752 21.3197 21.6087 20.9594 21.3536 20.6937C21.0986 20.428 20.7527 20.2787 20.392 20.2787H19.6112ZM20.952 21.6954V22.9363C20.952 23.091 20.893 23.2393 20.7879 23.3487C20.6829 23.4581 20.5405 23.5196 20.392 23.5196H19.6112C19.4626 23.5196 19.3202 23.4581 19.2152 23.3487C19.1102 23.2393 19.0512 23.091 19.0512 22.9363V21.6954C19.0512 21.5407 19.1102 21.3923 19.2152 21.2829C19.3202 21.1735 19.4626 21.1121 19.6112 21.1121H20.392C20.5405 21.1121 20.6829 21.1735 20.7879 21.2829C20.893 21.3923 20.952 21.5407 20.952 21.6954ZM20.6872 24.8304H19.316C18.822 24.8306 18.3483 25.0351 17.999 25.3988C17.6496 25.7626 17.4532 26.2559 17.4528 26.7704V27.5704C17.4528 27.6487 17.4739 27.7254 17.5138 27.7917C17.5537 27.858 17.6107 27.9113 17.6784 27.9454C18.4088 28.2754 19.2037 28.4211 19.9984 28.3704C20.793 28.4211 21.588 28.2754 22.3184 27.9454C22.386 27.9113 22.443 27.858 22.4829 27.7917C22.5228 27.7254 22.544 27.6487 22.544 27.5704V26.7704C22.5435 26.257 22.348 25.7647 22 25.4012C21.652 25.0376 21.18 24.8324 20.6872 24.8304ZM21.7504 27.2971C21.1868 27.4897 20.5938 27.5711 20.0016 27.5371C19.4094 27.5711 18.8163 27.4897 18.2528 27.2971V26.7704C18.2532 26.4769 18.3654 26.1955 18.5647 25.9881C18.764 25.7806 19.0342 25.664 19.316 25.6638H20.6872C20.9689 25.664 21.2391 25.7806 21.4384 25.9881C21.6378 26.1955 21.7499 26.4769 21.7504 26.7704V27.2971ZM23.0528 21.1854C23.0528 21.6274 23.2213 22.0514 23.5214 22.3639C23.8214 22.6765 24.2284 22.8521 24.6528 22.8521H25.7616C26.1859 22.8521 26.5929 22.6765 26.8929 22.3639C27.193 22.0514 27.3616 21.6274 27.3616 21.1854V19.4729C27.3616 19.0309 27.193 18.607 26.8929 18.2944C26.5929 17.9818 26.1859 17.8063 25.7616 17.8063H24.6528C24.2284 17.8063 23.8214 17.9818 23.5214 18.2944C23.2213 18.607 23.0528 19.0309 23.0528 19.4729V21.1854ZM23.8528 19.4729C23.8528 19.2519 23.937 19.0399 24.0871 18.8837C24.2371 18.7274 24.4406 18.6396 24.6528 18.6396H25.7616C25.9737 18.6396 26.1772 18.7274 26.3272 18.8837C26.4773 19.0399 26.5616 19.2519 26.5616 19.4729V21.1854C26.5616 21.4064 26.4773 21.6184 26.3272 21.7747C26.1772 21.931 25.9737 22.0187 25.7616 22.0187H24.6528C24.4406 22.0187 24.2371 21.931 24.0871 21.7747C23.937 21.6184 23.8528 21.4064 23.8528 21.1854V19.4729ZM19.1776 17.9829C19.4264 18.1387 19.7113 18.2209 20.0016 18.2209C20.2919 18.2209 20.5767 18.1387 20.8256 17.9829C22.8888 16.6963 23.1968 15.3037 23.1968 14.5887C23.2142 14.3262 23.1814 14.0626 23.1002 13.8134C23.019 13.5642 22.891 13.3342 22.7238 13.137C22.5565 12.9397 22.3533 12.7791 22.1259 12.6643C21.8985 12.5496 21.6514 12.4831 21.3992 12.4688C20.8895 12.469 20.3957 12.653 20.0016 12.9896C19.6074 12.653 19.1136 12.469 18.604 12.4688C18.3519 12.4832 18.1051 12.5496 17.8779 12.6641C17.6506 12.7787 17.4475 12.9391 17.2803 13.1361C17.113 13.3331 16.985 13.5627 16.9037 13.8117C16.8223 14.0606 16.7892 14.3239 16.8064 14.5863C16.8064 15.3038 17.1144 16.6963 19.1776 17.9829ZM18.604 13.3021C18.8091 13.3027 19.0118 13.3496 19.1979 13.4395C19.384 13.5294 19.5493 13.6602 19.6824 13.8229C19.7212 13.8721 19.7701 13.9118 19.8254 13.939C19.8807 13.9662 19.9412 13.9803 20.0024 13.9803C20.0635 13.9803 20.124 13.9662 20.1793 13.939C20.2346 13.9118 20.2835 13.8721 20.3224 13.8229C20.4562 13.6618 20.6215 13.5323 20.8071 13.4429C20.9928 13.3535 21.1946 13.3064 21.3992 13.3046C21.5455 13.3205 21.6873 13.3663 21.8166 13.4393C21.9459 13.5123 22.0602 13.6112 22.1528 13.7302C22.2454 13.8492 22.3147 13.9861 22.3565 14.1329C22.3984 14.2798 22.4121 14.4339 22.3968 14.5863C22.3968 15.5029 21.6768 16.4796 20.4152 17.2662C20.2897 17.3428 20.1469 17.3831 20.0016 17.3831C19.8562 17.3831 19.7134 17.3428 19.588 17.2662C18.3288 16.4821 17.6064 15.5029 17.6064 14.5863C17.5907 14.4337 17.6042 14.2794 17.6459 14.1322C17.6876 13.985 17.7567 13.8479 17.8494 13.7286C17.9421 13.6093 18.0564 13.5102 18.1859 13.437C18.3154 13.3638 18.4574 13.318 18.604 13.3021Z" fill="white" />
                                </svg> */}

                    <p>What about family plans?</p>
                  </Container>

                  <div
                    style={{
                      maxHeight: "50vh",
                      overflow: "auto",
                    }}
                  >
                    <div className="job-columns">
                      {familyOptions.map((family, index) => (
                        <div
                          key={index}
                          className="job-item"
                          onClick={() => setSelectedWantKids(family)}
                          style={{
                            backgroundColor:
                              selectedWantKids?.id === family?.id
                                ? "#F7ECFF"
                                : "transparent",
                          }}
                        >
                          {family?.name}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: "5px" }}>
                  {errorMessageWantKids && (
                    <p className="text-danger error-message">
                      {errorMessageWantKids}
                    </p>
                  )}
                </div>
              </Container>
            </div>
          </div>
          <div className="d-flex justify-content-center next-btn">
            <Button
              variant="primary"
              style={{
                width: "148px",
                marginTop: "1rem",
                background: "white",
                border: "2px solid #6c6c6c",
                borderRadius: "9999px",
                padding: "0.75rem",
                fontSize: "16px",
                fontWeight: "600",
                color: "#6c6c6c",
              }}
              onClick={() => navigate("/smoke-drink")}
            >
              Ask me later
            </Button>
            <Button
              variant="primary"
              style={{
                width: "148px",
                marginTop: "1rem",
                // background: "linear-gradient(180deg, #FC8C66 -4.17%, #F76A7B 110.42%)",
                background:
                  !selectedHaveKids || !selectedWantKids
                    ? "Lightgray"
                    : "linear-gradient(180deg, #FC8C66 -4.17%, #F76A7B 110.42%)",
                border: "none",
                borderRadius: "9999px",
                padding: "0.75rem",
                fontSize: "16px",
                fontWeight: "600",
                //   color: (!selectedHaveKids || !selectedWantKids) ? "Lightgray" : "white"
              }}
              onClick={saveAll}
              disabled={loading}
            >
              {loading ? (
                <Spinner animation="border" size="sm" role="status" />
              ) : (
                "Next"
              )}
            </Button>
          </div>
        </Container>
      </Container>
    </div>
  );
};



